/* assets/inkhelp.js */
(function () {
  "use strict";

  var CFG = {
    waPhoneDigits: "19312626820",
    email: "support@ink-pod.com",
    shippingUrl: "https://www.ink-pod.com/pages/shipping",
    trackUrl: "https://www.ink-pod.com/apps/parcelpanel"
  };

  function qs(sel, root){ return (root || document).querySelector(sel); }
  function qsa(sel, root){ return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function safeProductUrl(){
    var canonical = document.querySelector('link[rel="canonical"]');
    if (canonical && canonical.href) return canonical.href;
    return String(window.location.href || "").split("#")[0];
  }

  function buildWhatsAppLink(message){
    return "https://wa.me/" + CFG.waPhoneDigits + "?text=" + encodeURIComponent(message);
  }

  function openWhatsApp(){
    var msg = "Hi! I need help with this product:\n\n" + safeProductUrl();
    window.open(buildWhatsAppLink(msg), "_blank", "noopener,noreferrer");
  }

  function mailtoHref(){
    var subject = encodeURIComponent("Support Request - INK-POD");
    var body = encodeURIComponent(
      "Hi INK-POD Support,\n\n" +
      "I need help with my order / customization.\n\n" +
      "Product link:\n" + safeProductUrl() + "\n\n" +
      "Thanks."
    );
    return "mailto:" + CFG.email + "?subject=" + subject + "&body=" + body;
  }

  function removeExisting(){
    var r = qs(".inkhelp-root");
    var p = qs(".inkhelp-panel");
    var o = qs(".inkhelp-overlay");
    if (r) r.remove();
    if (p) p.remove();
    if (o) o.remove();
    document.body && document.body.classList.remove("inkhelp-open");
  }

  function isVisibleFixedBottom(el){
    if (!el) return false;
    var st = window.getComputedStyle(el);
    if (!st) return false;
    if (st.display === "none" || st.visibility === "hidden" || Number(st.opacity) === 0) return false;
    if (st.position !== "fixed" && st.position !== "sticky") return false;
    var rect = el.getBoundingClientRect();
    if (rect.height < 28) return false;
    return rect.bottom > (window.innerHeight - 5);
  }

  function calcBottomOffset(){
    var base = (window.innerWidth >= 769) ? 20 : 16;
    var extra = 0;

    var candidates = []
      .concat(qsa('[data-sticky-add-to-cart]'))
      .concat(qsa('.sticky-add-to-cart, .sticky-atc, .product-sticky, .product__sticky, .sticky-cart, .sticky-cart-bar'))
      .concat(qsa('#sticky-add-to-cart, #sticky-atc'))
      .concat(qsa('iframe[src*="whatsapp"], iframe[src*="tawk"], iframe[src*="crisp"], iframe[src*="intercom"], iframe[src*="zendesk"]'));

    candidates.forEach(function(el){
      if (!el || !el.getBoundingClientRect) return;
      if (!isVisibleFixedBottom(el)) return;
      var rect = el.getBoundingClientRect();
      extra = Math.max(extra, rect.height);
    });

    var padding = extra > 0 ? 12 : 0;
    return Math.round(base + extra + padding);
  }

  function applyBottomOffset(){
    document.documentElement.style.setProperty("--inkhelp-bottom", calcBottomOffset() + "px");
  }

  function inject(){
    if (!document.body) return;
    if (qs(".inkhelp-root")) return;

    var waSvg =
      '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
        '<path fill="currentColor" d="M12 2a10 10 0 0 0-8.66 15l-1.02 3.73 3.82-1A10 10 0 1 0 12 2zm0 18a8 8 0 0 1-4.08-1.12l-.3-.18-2.27.6.61-2.2-.2-.31A8 8 0 1 1 12 20zm4.42-5.56c-.24-.12-1.42-.7-1.64-.78-.22-.08-.38-.12-.54.12-.16.24-.62.78-.76.94-.14.16-.28.18-.52.06-.24-.12-1-.37-1.9-1.18-.7-.62-1.17-1.39-1.31-1.63-.14-.24-.01-.37.11-.49.11-.11.24-.28.36-.42.12-.14.16-.24.24-.4.08-.16.04-.3-.02-.42-.06-.12-.54-1.3-.74-1.78-.19-.46-.38-.4-.54-.41h-.46c-.16 0-.42.06-.64.3-.22.24-.84.82-.84 2 0 1.18.86 2.32.98 2.48.12.16 1.69 2.58 4.1 3.62.57.24 1.01.38 1.36.48.57.18 1.09.16 1.5.1.46-.07 1.42-.58 1.62-1.14.2-.56.2-1.04.14-1.14-.06-.1-.22-.16-.46-.28z"/>' +
      '</svg>';

    var mailSvg =
      '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
        '<path fill="currentColor" d="M20 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm0 4-8 5L4 8V6l8 5 8-5v2z"/>' +
      '</svg>';

    var overlay = document.createElement("div");
    overlay.className = "inkhelp-overlay";

    var panel = document.createElement("div");
    panel.className = "inkhelp-panel";
    panel.setAttribute("role", "dialog");
    panel.setAttribute("aria-modal", "false");
    panel.setAttribute("aria-label", "Help panel");

    panel.innerHTML =
      '<div class="inkhelp-head">' +
        '<div class="inkhelp-title">' +
          '<strong>Need help with customization?</strong>' +
          '<span>Fast answers + contact support in 1 click.</span>' +
        '</div>' +
        '<button class="inkhelp-close" type="button" aria-label="Close">×</button>' +
      '</div>' +
      '<div class="inkhelp-body">' +

        '<div class="inkhelp-actions">' +
          '<button class="inkhelp-cta inkhelp-wa" type="button" aria-label="Chat on WhatsApp">' +
            '<span class="inkhelp-ico">' + waSvg + '</span>' +
            '<span>WhatsApp</span>' +
          '</button>' +
          '<a class="inkhelp-cta inkhelp-em" href="' + mailtoHref() + '" aria-label="Email support">' +
            '<span class="inkhelp-ico">' + mailSvg + '</span>' +
            '<span>Email</span>' +
          '</a>' +
        '</div>' +

        '<div class="inkhelp-section-title">Quick FAQs</div>' +

        '<div class="inkhelp-qitem">' +
          '<button class="inkhelp-qbtn" type="button" aria-expanded="false">' +
            '<strong>Delivery time (production + shipping)</strong>' +
            '<span class="inkhelp-plus" aria-hidden="true">+</span>' +
          '</button>' +
          '<div class="inkhelp-ans">' +
            'Delivery time = production time + shipping time.<br>' +
            'Production: about <b>1–3 business days</b> (longer in peak season).<br>' +
            'Shipping varies by country. Please check our ' +
            '<a href="' + CFG.shippingUrl + '" target="_blank" rel="noopener noreferrer">Shipping page</a>.' +
          '</div>' +
        '</div>' +

        '<div class="inkhelp-qitem">' +
          '<button class="inkhelp-qbtn" type="button" aria-expanded="false">' +
            '<strong>How to change my design?</strong>' +
            '<span class="inkhelp-plus" aria-hidden="true">+</span>' +
          '</button>' +
          '<div class="inkhelp-ans">' +
            'You can request changes within <b>24 hours</b> after placing the order. ' +
            'Please contact us via WhatsApp or email as soon as possible and include your order info + product link.' +
          '</div>' +
        '</div>' +

        '<div class="inkhelp-qitem">' +
          '<button class="inkhelp-qbtn" type="button" aria-expanded="false">' +
            '<strong>How to track my order?</strong>' +
            '<span class="inkhelp-plus" aria-hidden="true">+</span>' +
          '</button>' +
          '<div class="inkhelp-ans">' +
            'Use our tracking page here: ' +
            '<a href="' + CFG.trackUrl + '" target="_blank" rel="noopener noreferrer">Track My Order</a>.' +
          '</div>' +
        '</div>' +

        '<div class="inkhelp-qitem">' +
          '<button class="inkhelp-qbtn" type="button" aria-expanded="false">' +
            '<strong>Can you ship to my country?</strong>' +
            '<span class="inkhelp-plus" aria-hidden="true">+</span>' +
          '</button>' +
          '<div class="inkhelp-ans">' +
            'Yes — we offer <b>worldwide shipping</b>.' +
          '</div>' +
        '</div>' +

      '</div>';

    var root = document.createElement("div");
    root.className = "inkhelp-root";
    root.innerHTML =
      '<button class="inkhelp-btn" type="button" aria-label="Help" aria-haspopup="dialog" aria-expanded="false">' +
        '<span class="inkhelp-q">?</span>' +
        '<span>HELP</span>' +
      '</button>';

    document.body.appendChild(overlay);
    document.body.appendChild(panel);
    document.body.appendChild(root);

    var btn = qs(".inkhelp-btn", root);
    var close = qs(".inkhelp-close", panel);
    var waBtn = qs(".inkhelp-wa", panel);

    function isOpen(){ return panel.classList.contains("is-open"); }
    function setOpen(open){
      btn.setAttribute("aria-expanded", String(open));
      overlay.classList.toggle("is-open", open);
      panel.classList.toggle("is-open", open);
      document.body.classList.toggle("inkhelp-open", open);
      applyBottomOffset();
    }

    btn.addEventListener("click", function(e){
      e.preventDefault();
      setOpen(!isOpen());
    });

    close.addEventListener("click", function(){ setOpen(false); });
    overlay.addEventListener("click", function(){ setOpen(false); });

    document.addEventListener("keydown", function(e){
      if (e.key === "Escape") setOpen(false);
    });

    waBtn.addEventListener("click", function(e){
      e.preventDefault();
      openWhatsApp();
    });

    panel.querySelectorAll(".inkhelp-qbtn").forEach(function(qb){
      qb.addEventListener("click", function(){
        var wrap = qb.closest(".inkhelp-qitem");
        var icon = qb.querySelector(".inkhelp-plus");
        var open = wrap.classList.toggle("is-open");
        qb.setAttribute("aria-expanded", String(open));
        if (icon) icon.textContent = open ? "–" : "+";
        applyBottomOffset();
      });
    });

    applyBottomOffset();
  }

  function boot(){
    applyBottomOffset();
    inject();

    var raf = 0;
    function schedule(){
      if (raf) return;
      raf = requestAnimationFrame(function(){
        raf = 0;
        applyBottomOffset();
      });
    }
    window.addEventListener("resize", schedule, { passive: true });
    window.addEventListener("scroll", schedule, { passive: true });

    var tries = 0;
    var timer = setInterval(function(){
      schedule();
      if (qs(".inkhelp-root")) { clearInterval(timer); return; }
      inject();
      tries++;
      if (tries >= 25) clearInterval(timer);
    }, 350);

    var mo = new MutationObserver(function(){
      schedule();
      if (!qs(".inkhelp-root") && document.body) {
        removeExisting();
        inject();
      }
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });

    document.addEventListener("shopify:section:load", function(){
      schedule();
      if (!qs(".inkhelp-root")) { removeExisting(); inject(); }
    });
  }

  if (document.readyState === "complete" || document.readyState === "interactive") boot();
  else document.addEventListener("DOMContentLoaded", boot);

})();
